import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// styles and images
import deleteValue from "../../assets/delete.svg";
import Download from "../../assets/download.svg";
import DollarSign from "../../assets/dollar_sign.svg";
import BlackLike from "../../assets/black-like.png";
import BlackDislike from "../../assets/black-dislike.png";
import Add from "../../assets/add_circle.svg";

import "../project/Project.css";
import "./VendorInvoices.css";

// global
import { accountDataStore, projectStore, userStore } from "../../store/Store";

// funcs
import { vendorInvoiceStatusStyles } from "../../data/collections-data";
import useDownloadProjectInvoice from "../../hooks/useDownloadProjectInvoice";

export default function VendorInvoiceRows({
  invoiceType,
  setDeleteTrigger,
  setDeleteId,
  displayInvoices,
  setUpdateBody,
  setUpdateTrigger,
  setAdjustmentTrigger,
  setFscMethodTrigger,
  fscMethod,
  fscMethodTrigger,
}) {
  const projectVendorInvoiceTotals = projectStore(
    (data) => data.projectVendorInvoiceTotals,
  );
  const currentProject = projectStore((data) => data.currentProject);
  const currentCompany = userStore((data) => data.currentCompany);
  const invoiceAdjustments = accountDataStore(
    (data) => data.invoiceAdjustments,
  );
  // local
  const [downloadPending, setDownloadPending] = useState(false);
  const [invoiceForDownload, setInvoiceForDownload] = useState();
  const navigate = useNavigate();
  const { id } = useParams("id");

  const handleClick = (inv) => {
    var type;
    if (!inv.is_asset && !inv.is_sand) {
      type = "freight";
    } else if (inv.is_sand) {
      type = "sand";
    } else if (inv.is_asset) {
      type = "asset";
    }
    navigate(`/project/${id}/invoices/vendor-invoices/${type}/${inv.id}`);
  };

  const handleStatus = (s, invoice) => {
    setUpdateBody({
      id: invoice.id,
      invoice_name: invoice.invoice_name,
      invoice_status_id: s,
      invoice_comments: invoice.invoice_comments,
      project_id: parseInt(id),
    });
    setUpdateTrigger(true);
  };

  const getUpdateAction = (invoice) => {
    switch (invoice.invoice_status_id) {
      case 29:
        return (
          <img
            className="account-invoice-action"
            src={DollarSign}
            onClick={() => handleStatus(31, invoice)}
            alt="dollar-sign"
          />
        );
      case 32:
        if (!currentCompany.customer_approval_required) {
          return (
            <div className="d-flex" style={{ margin: "0 0 0 10px" }}>
              <img
                className="account-invoice-action"
                style={{ margin: "0 5px 0 0" }}
                src={BlackLike}
                alt="black-like"
                onClick={() => handleStatus(29, invoice)}
              />{" "}
              <img
                className="account-invoice-action"
                src={BlackDislike}
                style={{ margin: "0 5px 0 0" }}
                alt="black-dislike"
                onClick={() => handleStatus(30, invoice)}
              />
            </div>
          );
        } else if (
          invoice.customer_approval_status_id !== 22 &&
          invoice.customer_approval_status_id !== 25 &&
          invoice.customer_approval_status_id !== 25
        ) {
          return (
            <div className="d-flex" style={{ margin: "0 0 0 10px" }}>
              <img
                className="account-invoice-action"
                style={{ margin: "0 5px 0 0" }}
                src={BlackLike}
                alt="black-like"
                onClick={() => handleStatus(29, invoice)}
              />{" "}
              <img
                className="account-invoice-action"
                src={BlackDislike}
                style={{ margin: "0 5px 0 0" }}
                alt="black-dislike"
                onClick={() => handleStatus(30, invoice)}
              />
            </div>
          );
        }
        break;
      default:
        return <p></p>;
    }
  };

  const handleDelete = (id) => {
    setDeleteId(id);
    setDeleteTrigger(true);
  };

  const initiateDownload = (inv) => {
    if (currentProject.project.fsc_area_id !== "" && !inv.is_asset) {
      setFscMethodTrigger(true);
      setInvoiceForDownload(inv);
    } else {
      setInvoiceForDownload(inv);
    }
  };

  useDownloadProjectInvoice(
    false,
    fscMethodTrigger,
    currentProject,
    setDownloadPending,
    fscMethod,
    invoiceForDownload,
    false,
    null,
  );

  const getTotals = (inv) => {
    var totals = {
      weight: 0,
      weight_diff: 0,
      cost: 0,
      cost_diff: 0,
      duplicate_ticket_count: 0,
      duplicate_load_count: 0,
      missing_ticket_count: 0,
      locked_load_count: 0,
      canceled_load_count: 0,
      invoice_adjustment: 0,
      missing_load_count: 0,
      net: 0,
    };
    const total = projectVendorInvoiceTotals.filter(
      (x) => x.invoice_id === inv.id,
    );

    if (total.length > 0) {
      totals.weight = total[0].calculated_weight;
      totals.weight_diff = inv.total_weight_tons - total[0].calculated_weight;
      totals.cost = total[0].calculated_cost;
      totals.cost_diff = inv.total_cost - total[0].calculated_cost;
      totals.duplicate_ticket_count = total[0].duplicate_ticket_count;
      totals.duplicate_load_count = total[0].duplicate_load_count;
      totals.missing_ticket_count = total[0].missing_ticket_count;
      totals.locked_load_count = total[0].locked_load_count;
      totals.canceled_load_count = total[0].canceled_load_count;
      totals.missing_load_count = total[0].missing_load_count;
      totals.net = totals.cost;
    }

    var adj;
    if (invoiceAdjustments) {
      adj = invoiceAdjustments.filter((x) => x.invoice_id === inv.id);
      if (adj.length > 0) {
        totals.invoice_adjustment = parseFloat(adj[0].total_adjustment);
      }
    }

    totals.net = totals.cost + totals.invoice_adjustment;
    return totals;
  };
  const getAdjustment = (inv) => {
    if (invoiceAdjustments) {
      const adj = invoiceAdjustments.filter((x) => x.invoice_id === inv.id);
      if (
        adj.length === 0 &&
        inv.invoice_status_id !== 30 &&
        inv.invoice_status_id !== 31
      ) {
        return (
          <img
            src={Add}
            alt="add"
            onClick={() => {
              setAdjustmentTrigger(true);
              setUpdateBody(inv);
            }}
            className="edit"
          />
        );
      }
    } else if (inv.invoice_status_id !== 30 && inv.invoice_status_id !== 31) {
      return (
        <img
          src={Add}
          alt="add"
          onClick={() => {
            setAdjustmentTrigger(true);
            setUpdateBody(inv);
          }}
          className="edit"
        />
      );
    }
  };

  return displayInvoices &&
    invoiceType === "Freight" &&
    projectVendorInvoiceTotals ? (
    <>
      {displayInvoices.map(
        (inv, idx) =>
          !inv.is_sand &&
          !inv.is_asset && (
            <tr key={idx}>
              <td
                onClick={() => handleClick(inv)}
                style={{ cursor: "pointer" }}
              >
                {inv.vendor_name}
              </td>
              <td
                onClick={() => handleClick(inv)}
                style={{ cursor: "pointer" }}
              >
                {inv.invoice_name}
              </td>
              <td>{inv.total_loads}</td>
              <td>{getTotals(inv).duplicate_ticket_count}</td>
              <td>{getTotals(inv).duplicate_load_count}</td>
              <td>{getTotals(inv).missing_ticket_count}</td>
              <td>{getTotals(inv).missing_load_count}</td>
              <td>{getTotals(inv).canceled_load_count}</td>
              <td>{getTotals(inv).locked_load_count}</td>
              <td>
                {inv.total_weight_tons.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>
                {getTotals(inv).weight.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>
                {getTotals(inv).weight_diff.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>
                $
                {inv.freight_cost.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>
                $
                {inv.fsc_cost.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>
                $
                {inv.total_cost.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>
                $
                {getTotals(inv).cost.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>
                $
                {getTotals(inv).cost_diff.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>
                $
                {getTotals(inv).invoice_adjustment.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>
                $
                {getTotals(inv).net.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>{inv.discount_percent}%</td>
              <td className="status-column">
                <div
                  className={
                    vendorInvoiceStatusStyles[inv.customer_approval_status_id]
                  }
                >
                  {inv.customer_approval_status_id === 23 ||
                  inv.customer_approval_status_id === 24
                    ? "Approved"
                    : inv.customer_approval_status_id === 21 ||
                        inv.customer_approval_status_id === 25
                      ? "Pending"
                      : inv.customer_approval_status_id === 22
                        ? "Disputed"
                        : inv.customer_approval_status_id === 0 && ""}
                </div>
              </td>
              <td className="action">
                {!downloadPending && getUpdateAction(inv)}
              </td>
              {!currentProject.project.archived && !downloadPending && (
                <td className="action">
                  <div>
                    <img
                      src={deleteValue}
                      onClick={() => handleDelete(inv.id)}
                      className="edit"
                      alt="delete"
                    />
                    <img
                      src={Download}
                      onClick={() => initiateDownload(inv)}
                      className="edit"
                      alt="download"
                    />
                    {getAdjustment(inv)}
                  </div>
                </td>
              )}
            </tr>
          ),
      )}
    </>
  ) : displayInvoices &&
    invoiceType === "Sand" &&
    projectVendorInvoiceTotals ? (
    <>
      {displayInvoices.map(
        (inv, idx) =>
          inv.is_sand && (
            <tr key={idx}>
              <td
                onClick={() => handleClick(inv)}
                style={{ cursor: "pointer" }}
              >
                {inv.vendor_name}
              </td>
              <td
                onClick={() => handleClick(inv)}
                style={{ cursor: "pointer" }}
              >
                {inv.invoice_name}
              </td>
              <td>{inv.total_loads}</td>
              <td>{getTotals(inv).duplicate_ticket_count}</td>
              <td>{getTotals(inv).duplicate_load_count}</td>
              <td>{getTotals(inv).missing_ticket_count}</td>
              <td>{getTotals(inv).missing_load_count}</td>
              <td>{getTotals(inv).canceled_load_count}</td>
              <td>{getTotals(inv).locked_load_count}</td>
              <td>
                {inv.total_weight_tons.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>
                {getTotals(inv).weight.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>
                {getTotals(inv).weight_diff.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>
                $
                {inv.sand_cost.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>
                $
                {inv.total_cost.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>
                $
                {getTotals(inv).cost.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>
                $
                {getTotals(inv).cost_diff.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>
                $
                {getTotals(inv).invoice_adjustment.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>
                $
                {getTotals(inv).net.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td>{inv.discount_percent}%</td>
              <td className="action">{getUpdateAction(inv)}</td>
              <td className="action">
                <img
                  src={deleteValue}
                  onClick={() => handleDelete(inv.id)}
                  className="edit"
                  alt="edit"
                />
              </td>
            </tr>
          ),
      )}
    </>
  ) : (
    displayInvoices &&
    invoiceType === "Asset" &&
    projectVendorInvoiceTotals && (
      <>
        {displayInvoices.map(
          (inv, idx) =>
            inv.is_asset && (
              <tr key={idx}>
                <td
                  onClick={() => handleClick(inv)}
                  style={{ cursor: "pointer" }}
                >
                  {inv.vendor_name}
                </td>
                <td
                  onClick={() => handleClick(inv)}
                  style={{ cursor: "pointer" }}
                >
                  {inv.invoice_name}
                </td>
                <td>{inv.total_loads}</td>
                <td>{getTotals(inv).duplicate_load_count}</td>
                <td>{getTotals(inv).missing_load_count}</td>
                <td>{getTotals(inv).locked_load_count}</td>
                <td>{inv.total_weight_tons.toFixed(2)}</td>
                <td>{getTotals(inv).weight.toFixed(2)}</td>
                <td>{getTotals(inv).weight_diff.toFixed(2)}</td>
                <td>
                  $
                  {inv.freight_cost.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td>
                  $
                  {inv.fsc_cost.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td>
                  $
                  {inv.total_cost.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td>
                  $
                  {getTotals(inv).cost.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td>
                  $
                  {getTotals(inv).cost_diff.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td>
                  $
                  {getTotals(inv).invoice_adjustment.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td>
                  $
                  {getTotals(inv).net.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td>{inv.discount_percent}%</td>
                <td className="status-column">
                  <div
                    className={
                      vendorInvoiceStatusStyles[inv.customer_approval_status_id]
                    }
                  >
                    {inv.customer_approval_status_id === 23 ||
                    inv.customer_approval_status_id === 24
                      ? "Approved"
                      : inv.customer_approval_status_id === 21 ||
                          inv.customer_approval_status_id === 25
                        ? "Pending"
                        : inv.customer_approval_status_id === 22
                          ? "Disputed"
                          : inv.customer_approval_status_id === 0 && ""}
                  </div>
                </td>
                <td className="action">{getUpdateAction(inv)}</td>
                {!currentProject.project.archived && (
                  <td className="action">
                    <div>
                      <img
                        src={deleteValue}
                        onClick={() => handleDelete(inv.id)}
                        className="edit"
                        alt="delete"
                      />
                      <img
                        src={Download}
                        onClick={() => initiateDownload(inv)}
                        className="edit"
                        alt="download"
                      />
                    </div>
                  </td>
                )}
              </tr>
            ),
        )}
      </>
    )
  );
}
